import { GetInitiatorRules } from "@/api/user";

// 审核功能
export default {
  data() {
    return {
      draftIndex: 0,
      ApprovalList: [],
      ApproveKeys: [],
      ApproveState: false,
    };
  },
  mounted() {
    this.CheckApprove();
    console.log(this.draftTitle[this.draftIndex]);
  },
  methods: {
    async CheckApprove() {
      let res = await GetInitiatorRules({
        TableKey: this.draftTitle[this.draftIndex],
      });
      if (res.Code == 0 && res.Data) {
        let list = [];
        let state = false;
        for (let item of res.Data) {
          let arr = [];
          if (item.Approver == 4) state = true;
          let idlist = item.datalist[0].UserID.split(",");
          let namelist = item.datalist[0].UserName.split(",");
          for (let i = 0; i < idlist.length; i++) {
            arr.push({
              UserID: idlist[i],
              UserName: namelist[i],
            });
          }
          list.push({
            Approver: item.Approver,
            ApprovalMethod: item.ApprovalMethod,
            list: arr,
            showlist: item.Approver == 4 ? [] : arr,
          });
        }
        if (state) {
          this.ApprovalList = list;
          this.ApproveState = true;
        }
      } else {
        this.ApproveState = false;
      }
    },
    SetApproveKeys(e) {
      this.ApproveKeys = e;
      this.ApproveShow = false;
      this.ApproveState = false;
      this.append();
    },
  },
};
